module.exports = __webpack_public_path__ + "static/media/telegram.171c26eb.svg";